/**
 * Typed cache keys for the organization feature (Clients + Projects + Project Elements).
 *
 * Per ADR-0012: query keys are typed constants, never inline string arrays.
 */
export const organizationKeys = {
	clients: {
		all: ['clients'] as const,
		list: () => ['clients'] as const,
	},
	projects: {
		all: ['projects'] as const,
		list: () => ['projects'] as const,
		detail: (projectId: string) => ['projects', projectId] as const,
	},
	projectElements: {
		list: (projectId: string | null) => ['project-elements', projectId] as const,
	},
}
